import { pickAppCopy, type SupportedLocale } from "@patient-watch/i18n";
import { useMemo } from "react";
import { useAppLocale } from "./LocaleContext";
import { listCopyEn } from "@patient-watch/i18n/webapp/en-GB/listCopy";
import { listCopyDe } from "@patient-watch/i18n/webapp/de-DE/listCopy";
import { listCopyDa } from "@patient-watch/i18n/webapp/da-DK/listCopy";
import { listCopyEnUs } from "@patient-watch/i18n/webapp/en-US/listCopy";
import { listCopyFr } from "@patient-watch/i18n/webapp/fr-FR/listCopy";
import { listCopyIt } from "@patient-watch/i18n/webapp/it-IT/listCopy";
import { listCopyEs } from "@patient-watch/i18n/webapp/es-ES/listCopy";

/** Shared list and table labels used across Team, Studies, Patients, and Templates. */
export interface ListCopy {
    published: string;
    draft: string;
    name: string;
    role: string;
    organisation: string;
    email: string;
    dateOfBirth: string;
    labels: string;
    status: string;
    actions: string;
}

const listCopy: Record<SupportedLocale, ListCopy> = {
    "en-GB": listCopyEn,
    "en-US": listCopyEnUs,
    "de-DE": listCopyDe,
    "da-DK": listCopyDa,
    "fr-FR": listCopyFr,
    "it-IT": listCopyIt,
    "es-ES": listCopyEs,
};

export function getListCopy(locale: SupportedLocale): ListCopy {
    return pickAppCopy(listCopy, locale);
}

export function useListCopy(): ListCopy {
    const { locale } = useAppLocale();
    return useMemo(() => getListCopy(locale), [locale]);
}
